import { useStore } from '../context/StoreContext';
import { Icon } from '../shared/ui/Icon';
import { formatPrice } from '../entities/product/helpers';

export function OrderCompletePage() {
  const { user, orderComplete, showAccount } = useStore();

  return (
    <section className="empty-state order-complete">
      <span className="complete-check">✓</span>
      <p className="eyebrow">ORDER RECEIVED</p>
      <h1>Thanks, {user?.name?.split(' ')[0] || 'friend'}.</h1>
      <p>
        Your order <b>#{String(orderComplete?.id || '').slice(-7).toUpperCase()}</b> is in good hands.
        We'll keep you updated.
      </p>
      <div className="completion-total">
        Order total <b>{formatPrice(orderComplete?.total)}</b>
      </div>
      <button className="button button-primary" onClick={showAccount}>
        View your orders <Icon>↗</Icon>
      </button>
    </section>
  );
}
